import { hexToRgb } from '@mui/material';

export function hexToRgba(hex: string, alpha: number) {
  const rgb = hexToRgb(hex);
  const rgba = rgb.replace('(', 'a(').replace(')', `, ${alpha})`);
  return rgba;
}
